import { ActionTree } from 'vuex';
import axios from 'axios';
import { MsgTransports, RootState, transportsMap } from '../types';
import { TransportsState } from './types';

export const actions: ActionTree<TransportsState, RootState> ={
  getTransports: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      axios({url: '/lk-api/user/info/transports'})
        .then(resp => {
          commit('setTransports', resp.data.transports);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getTransportsMultichannel: ({commit, dispatch}, transport: MsgTransports) => {
    // const transportId = transportsMap.get(transport);
    return new Promise((resolve, reject) => {
      axios({url: `/lk-api/transport/multichannel?transportName=${transport}`})
        .then(resp => {
          commit('setTransportsMultichannel', resp.data);
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
};